export const mailingAddressFieldMap = {
  address: 'mailing_street',
  city: 'mailing_city',
  state: 'mailing_state',
  zip: 'mailing_zip_code'
}
